import { Component, OnInit } from '@angular/core';
import { FirebaseService } from 'src/app/services/firebase/firebase.service';
import { Router } from '@angular/router';
import { UtilsService } from 'src/app/services/utils.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loading: boolean;
  user;
  form;

  constructor(private route: Router, private toastCtrl: UtilsService, private firestore_service: FirebaseService) { }

  ngOnInit(): void {
    this.setEmptyForm();
    this.loading = false;
  }

  login(email, password){
    this.loading = true;
      this.firestore_service.loginUser(email, password).then(() => {
        this.firestore_service.getDataUser().then(() => {
          this.firestore_service.getUserId().then((user_id: any) => {
            this.firestore_service.getAccountRole(user_id).then(role => {
              if(role[0] == 'Admin') {
                this.route.navigate(['/admin-campaigns']);
              } else if(role[0] == 'Client') {
                this.route.navigate(['/campaigns']);
              } else if (role[0] == 'client_money'){
                this.route.navigate(['/test-space'])
              }
            })

          })
        })
      }).catch(() => {
        if(email && password){
          this.loading = false;
          let message = 'Usuario y/o contraseña no coinciden.';
          let title = 'Error de autenticación';
          this.toastCtrl.presentToast(message, title, 'error', 5500);
        } else {
          this.loading = false;
          let message = 'Ambos campos son obligatorios.';
          let title = 'Error de autenticación';
          this.toastCtrl.presentToast(message, title, 'error', 5500);
        }

      })
  }

  onSubmit(){
    this.login(this.form.email, this.form.password);
  }

  setEmptyForm(){
    this.form = {
        email: '',
        password: ''
    }
  }

}
